export const SUBJECT = 'subject';
export const COMMENTS = 'comments';
export const ATTACHMENT_IMAGE_BASE64 = 'attachmentImageBase64';
export const ATTACHMENT_IMAGE_FILE_NAME = 'attachmentImageFilename';
export const IMAGE_URL = 'imageUrl';
export const ATTACHMENT_BLOB_ID = 'attachmentImageSignedBlobId';
